/**
 * Canonical Zcash Sapling proving-key SHA-256 hashes.
 *
 * These are the well-known, public hashes of the *uncompressed* canonical
 * `.params` files distributed by Zcash. After we fetch the compressed
 * `.params.cz` shards from our CDN and decompress them in the Web
 * Worker, the resulting bytes MUST hash to one of these values — that's
 * what proves the supply chain is intact:
 *
 *   compressed bytes  →  decompressor  →  canonical bytes
 *                                        ↓
 *                                 SHA-256 must equal expected
 *
 * If a mismatch happens, the wallet refuses to write the bytes to
 * IndexedDB and the prover never sees them. Same canonical hashes the
 * Rust re-encoder verifies against (see
 * teleswap-bot/tools/sapling-params-recompress/README.md).
 */

export const CANONICAL_SHA256 = {
  saplingSpend:
    "8e48ffd23abb3a5fd9c5589204f32d9c31285a04b78096ba40a79b75677efc13",
  saplingOutput:
    "2f0ebbcbb9bb0bcffe95a397e7eba89c29eb4dde6191c339db88570e3f3fb0e4",
} as const;

export type ParamKind = keyof typeof CANONICAL_SHA256;

export const PARAM_FILES: Record<ParamKind, { compressed: string; canonicalSize: number }> = {
  saplingSpend: {
    compressed: "sapling-spend.params.cz",
    canonicalSize: 47_958_396,
  },
  saplingOutput: {
    compressed: "sapling-output.params.cz",
    canonicalSize: 3_592_860,
  },
};
